import Vue from "vue";
import gaService from "./ga.service";

export default {
    async openSession(options = { lang: "en", game }) {
        gaService.send("games", "doublechancelotto", "DoubleChanceLotto");
        return (await Vue.http.post("/api/doublechancelotto/session/open", Object.assign({}, options))).data;
    },
    async openDemoSession(options = { lang: "en", game }) {
        gaService.send("games", "doublechancelotto", "DoubleChanceLotto");
        return (await Vue.http.post("/api/doublechancelotto/session/opendemo", Object.assign({}, options))).data;
    },
    async closeSession() {
        return (await Vue.http.post("/api/doublechancelotto/session/close")).data;
    }
};


// WEBPACK FOOTER //
// ./_common/services/doubleChanceLotto.service.js